import script from "./DimensionWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./DimensionWidget.vue?vue&type=script&setup=true&lang=js"

import "./DimensionWidget.vue?vue&type=style&index=0&id=3891cfac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3891cfac"]])

export default __exports__